import React from 'react';
import '../../styles/components/skeleton.css';

/**
 * Skeleton loader pour la liste d'attractions
 * @param {number} count - Nombre d'items skeleton à afficher (défaut: 6)
 */
const AttractionsSkeleton = ({ count = 6 }) => {
  return (
    <div className="attractions-skeleton-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-attraction-item">
          <div className="skeleton-attraction-header">
            <div className="skeleton-attraction-name"></div>
            <div className="skeleton-wait-time"></div>
          </div>
          <div className="skeleton-attraction-details"></div>
        </div>
      ))}
    </div>
  );
};

export default AttractionsSkeleton;
